import Parcial from './Parcial';
export default Parcial;